<template>
  <div class="spaceCenter">
    <div>
      <div class="spaceLeft item-box">
        <label>祺信笔数：</label>
        <span class="text-color-blue" style="margin-right:5px;">{{ total }} </span> 笔
      </div>
      <div class="spaceLeft item-box">
        <label>祺信面额：</label>
        <span class="text-color-gold" style="margin-right:5px;">{{ totalAmt | splitK }} </span> 元
      </div>
      <div class="spaceLeft item-box">
        <label>交易密码：</label>
        <a-input type="password" v-model="txnPwd" class="item-input" />
      </div>
      <div class="spaceCenter model-footer-btns">
        <a-button @click="modalCancel">返回</a-button>
        <a-button @click="modalOk" type="primary" :loading="modalLoad" :disabled="!txnPwd">确认</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyTradePassword } from "@/api/gold.js";
export default {
  props: ["confirmData", "confirmModalData"],
  name: "confirmPasswordModal",
  data() {
    return {
      modalLoad: false,
      total: this.confirmData.length,
      txnPwd: "",
      totalAmt: 0
    };
  },
  computed: {
  },
  created() {

  },
  mounted() {
    this.renderTotalAmt();
  },
  methods: {
    modalOk(e) {
      this.modalLoad = true;
      let params = { tradePassword: this.txnPwd };
      verifyTradePassword(params, true)
        .then((res) => {
          let p = {
            txnPwd: this.utils.getPasswordEncryptString(this.txnPwd)
          }
          this.$emit("ok", p);
        })
        .catch((error) => {
          console.log(error)
          this.modalLoad = false;
          this.$emit("error", error);
        });
    },
    modalCancel(e) {
      this.modalLoad = false;
      this.$emit("cancel");
    },
    renderTotalAmt() {
      let list = this.confirmData || [];
      let sum = 0;
      list.forEach(i => sum += i.gldAmt);
      this.totalAmt = sum;
      this.total = list.length;
      this.txnPwd = "";
      this.modalLoad = false;
    }
  },
  watch: {
    confirmData(newVal) {
      this.renderTotalAmt();
    }
  }
};
</script>
<style scoped>
.item-box>label {
  min-width: 70px;
}

.item-box {
  margin: 0 15px 15px 0;
}

.item-input {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/gold-page/confirm-password-modal.vue